module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "[Contents]"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d7e6899"
    }
  }, [_c('b', [_vm._v("[")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Contents")]), _c('b', [_vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e6949"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c9_r1#d7e81911",
      "id": "d14e256"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e6999"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c11_r1#d7e99113",
      "id": "d14e260"
    }
  }, [_c('em', [_vm._v("Introduction:")]), _vm._v(" You Have a Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699a9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7069"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c12_r1#Anch0009",
      "id": "Anch00119"
    }
  }, [_c('b', [_vm._v("Part I—My Identity Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c13_r1#Anch0029",
      "id": "Anch00323"
    }
  }, [_vm._v("Choice 1: I Choose God’s Love")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7179"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c14_r1#Anch0049",
      "id": "Anch00543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 2: I Choose God’s Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699b9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7229"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c15_r1#Anch0069",
      "id": "Anch00771",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II—My Authority Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7279"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c17_r1#Anch0089",
      "id": "Anch00975",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 3: I Choose Jesus Christ as Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7329"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c18_r1#Anch0109",
      "id": "Anch01199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 4: I Choose the Bible as God’s Word")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699c9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7379"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c19_r1#Anch0149",
      "id": "Anch015131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III—My Capacity Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7429"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c21_r1#Anch0169",
      "id": "Anch017135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 5: I Choose to Forgive")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7489"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c25_r1#Anch0189",
      "id": "Anch019163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 6: I Choose to Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699d9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7539"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c26_r1#Anch0209",
      "id": "Anch021181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV—My Priority Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7589"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c28_r1#Anch0229",
      "id": "Anch023185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 7: I Choose to Love My Family First")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7639"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c29_r1#Anch0249",
      "id": "Anch025209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 8: I Choose to Be Authentic")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699e9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e77110"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c30_r1#Anch02610",
      "id": "Anch027233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part V—My Destiny Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e77610"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c32_r1#Anch02810",
      "id": "Anch029237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 9: I Choose to Serve")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e78110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c33_r1#Anch03010",
      "id": "Anch031261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice 10: I Choose to Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e699f9"
    }
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e78610"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c34_r1#Anch03210",
      "id": "Anch033283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e79110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c35_r1#Anch03410",
      "id": "Anch035288",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix A:")]), _vm._v(" That’s My King")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e79910"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c36_r1#Anch03610",
      "id": "Anch037290",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix B:")]), _vm._v(" Scriptures to Pray")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e80610"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c38_r1#Anch03810",
      "id": "Anch039293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e81110"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c39_r1#Anch04010",
      "id": "Anch041296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773e8132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MacD_ISBN9781418573447_epub_c7_r1.vue
// module id = 72
// module chunks = 0